export default "__VITE_ASSET__TzZbAdWiIJpOtdPQ4sgjbQ__"